export type CALLOUT_TYPE = "neutral" | "warning" | "positive" | "negative" | "info";
export type CALLOUT_SIZE = "sm" | "md";

export interface IActionCallout {
  calloutType: CALLOUT_TYPE;
  calloutMessage: string;
  calloutTooltip?: string;
}

export interface IEMActionCallout extends IActionCallout {
  isEMResult: boolean;
}

/**
 * Base Model storing properties required for a Callout
 */
export class CalloutModel implements IActionCallout {
  calloutType: CALLOUT_TYPE;
  calloutMessage: string;
  calloutTooltip: string;

  constructor(calloutType: CALLOUT_TYPE, calloutMessage: string, calloutTooltip?: string) {
    this.calloutType = calloutType;
    this.calloutMessage = calloutMessage;
    this.calloutTooltip = calloutTooltip;
  }

  public toString(): string {
    return `Callout(${this.calloutType} - ${this.calloutMessage}`;
  }
}

export class EMCalloutModel extends CalloutModel implements IEMActionCallout {
  public isEMResult: boolean = false;

  constructor(calloutType: CALLOUT_TYPE, calloutMessage: string, calloutTooltip?: string) {
    super(calloutType, calloutMessage, calloutTooltip);
  }
}
